import { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { UserContext } from "../../App";
import CheckToken from "../../_Login/CheckToken";
import DynamicGrid from "../../Tools/DynamicGrid";
import fetchWithRetries from "../../Tools/FetchWithRetries";
import GetCyclones from "../Tools/GetCyclones";

const Cyclones = () => {

    const [user, setUser] = useContext(UserContext);
    const navigate = useNavigate();

    //CheckToken(user["id"], user["token"]).then((result) => { if (!result) { setUser({}); navigate("/Login"); } });

    const [cyclones, setCyclones] = useState([]);

    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);

    useEffect(() => {

        fetchWithRetries(3, GetCyclones, (payload) => {
            let myCyclones = JSON.parse(payload).data;

            let cycloneList = myCyclones.map(c => (
                {
                    cycloneID: c[0],
                    cycloneName: c[1],
                    customer: c[2],
                    quoteNumber: c[3],
                    cycloneTypeSelection: c[4],
                    sizeModel: c[5],
                    sizeModelSize: c[6],
                    sizeModelType: c[7],
                    sizeModelCFM: c[8],
                    capType: c[9],
                    capTypeName: c[10],
                    screenedTubularGuard: c[11] == "True" ? "Yes" : "No",
                    desiredOperatingPressureLoss: c[12],
                    designAirflow1: c[13],
                    designAirflow2: c[14],
                    designAirflow3: c[15],
                    designAirflow4: c[16],
                    designAirflow5: c[17],
                    designAirflow6: c[18],
                    designAirflow7: c[19],
                    designAirflow8: c[20],
                    designAirflow9: c[21],
                    designAirflow10: c[22],
                    designAirflow1Notes: c[23],
                    designAirflow2Notes: c[24],
                    designAirflow3Notes: c[25],
                    designAirflow4Notes: c[26],
                    designAirflow5Notes: c[27],
                    designAirflow6Notes: c[28],
                    designAirflow7Notes: c[29],
                    designAirflow8Notes: c[30],
                    designAirflow9Notes: c[31],
                    designAirflow10Notes: c[32],
                    notes: c[33],
                    dateEntered: c[34],
                    dateModified: c[35],
                    createdBy: c[36],
                    createdByFirstName: c[37],
                    createdByLastName: c[38],
                    modifiedBy: c[39],
                    modifiedByFirstName: c[40],
                    modifiedByLastName: c[41],
                    totalDesignAirflow: Number(c[42]).toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 0 }),
                    numberLegs: c[43]
                }
            ));
            setCyclones(cycloneList);
        });

    }, []);

    useEffect(() => {

        if (cyclones.length > 0) {
            let rowsList = [];

            cyclones.forEach((entry, index) => {

                let cycloneID = entry["cycloneID"];
                let cycloneName = entry["cycloneName"];

                let row = [
                    { type: "link", content: { text: `${cycloneName}`, link: `/Cyclones/Details/${cycloneID}` } },
                    { type: "text", content: { text: `${entry["customer"]}` } },
                    { type: "text", content: { text: `${entry["quoteNumber"]}` } },
                    // { type: "text", content: { text: `${entry["cycloneTypeName"]}` } },
                    { type: "text", content: { text: `${entry["sizeModelType"]}` } },
                    { type: "text", content: { text: `${entry["sizeModelSize"]}` } },

                    { type: "text", content: { text: `${entry["totalDesignAirflow"]} CFM` } },
                    { type: "text", content: { text: `${entry["numberLegs"]}` } },
                    // { type: "text", content: { text: `${entry["sizeModelCFM"]}` } },                    
                    { type: "text", content: { text: `${entry["capTypeName"]}` } },
                    { type: "text", content: { text: `${entry["screenedTubularGuard"]}` } },
                    { type: "text", content: { text: `${entry["desiredOperatingPressureLoss"]}` } },
                    // { type: "text", content: { text: `${entry["dateEntered"]}` } },
                    { type: "text", content: { text: `${entry["modifiedByFirstName"]} ${entry["modifiedByLastName"]}` } },
                    { type: "text", content: { text: `${entry["dateModified"]}` } },
                    // { type: "text", content: { text: `${entry["createdByFirstName"]} ${entry["createdByLastName"]}` } },



                ];

                rowsList.push(row);
            });

            setColumns([
                "Cyclone Name",
                "Customer",
                "Quote Number",
                // "Cyclone Type",
                "Type",
                "Size",
                "Total Design Airflow",
                "Branches",
                // "Size Model CFM",
                "Outlet Cap",
                "Screened Tubular Guard",
                "Desired Operating Pressure Loss",
                // "Date Entered",
                "Modified By",
                "Last Modified"
                // "Created By",


            ]);
            setRows(rowsList);

        }
    }, [cyclones]);

    document.title = "Cyclones";
    return (
        <>
            <div className="cyclones">
                {user["email"] != undefined &&
                    <>
                        <div className="container" style={{ margin: "auto" }}>
                            <h2>Cyclones</h2>
                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start" }}>
                                    <p><Link className="btn btn-primary" to="/Cyclones/New">New Cyclone</Link></p>
                                </div>
                            </div>

                            {columns && rows && <DynamicGrid columnNames={columns} tableData={rows} sortable={true} defaultsortindex={11} descending={true} />}

                        </div>

                    </>
                }

            </div>
        </>
    );
}

export default Cyclones;